import { render } from "./basket.vue?vue&type=template&id=f54b5d94&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"

import "./basket.vue?vue&type=style&index=0&id=f54b5d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54b5d94"]])

export default __exports__